import { FASTElement as c, attr as p, observable as v } from "@microsoft/fast-element";
import { stepperStyles as m } from "./stepper.styles.js";
import { stepperTemplate as S } from "./stepper.template.js";
import { NumberStringConverter as f } from "../common/converters/number-string-converter.js";
var d = Object.defineProperty, r = (h, t, s, n) => {
  for (var i = void 0, a = h.length - 1, l; a >= 0; a--)
    (l = h[a]) && (i = l(t, s, i) || i);
  return i && d(t, s, i), i;
};
const o = class o extends c {
  constructor() {
    super(...arguments), this.activeStep = 0, this.skippable = !1, this.orientation = "horizontal", this.steps = [];
  }
  get isStepBeforeLast() {
    return this.activeStep === this.steps.length - 1;
  }
  get nextLabel() {
    var t;
    return (t = this.steps[this.activeStep + 1]) == null ? void 0 : t.getAttribute("label");
  }
  get showSkip() {
    return this.skippable && this.activeStep < this.steps.length - 1;
  }
  activeStepChanged() {
    this.$fastController.isConnected && this.setSteps();
  }
  stepsChanged() {
    this.$fastController.isConnected && this.setSteps();
  }
  setSteps() {
    this.steps.forEach((t, s) => {
      const n = this.activeStep === s;
      t.setAttribute("active", n.toString()), this.activeStep !== s ? t.setAttribute("hidden", "") : t.removeAttribute("hidden");
    });
  }
  handleClickNext() {
    this.activeStep !== void 0 && this.activeStep < this.steps.length - 1 && this.$emit("next", { from: this.activeStep });
  }
  handleClickBack() {
    this.activeStep > 0 && this.$emit("back", { from: this.activeStep });
  }
  handleClickCancel() {
    this.$emit("cancel", { from: this.activeStep });
  }
  handleClickSkip() {
    this.$emit("skip", { from: this.activeStep });
  }
  handleClickSubmit() {
    this.$emit("submit");
  }
};
o.definition = {
  name: "stepper",
  template: S,
  styles: () => m
};
let e = o;
r([
  p({ converter: f })
], e.prototype, "activeStep");
r([
  p
], e.prototype, "activeLabel");
r([
  p({ mode: "boolean" })
], e.prototype, "skippable");
r([
  p
], e.prototype, "orientation");
r([
  v
], e.prototype, "steps");
export {
  e as Stepper
};
